<template>
    <div>
        <div id="cxj-overlay-all-wrap" :class="overlayClass">
            <div id="cxj-overlay-close" @click="closeOverlay">
                <svg viewBox="0 0 24 24" width="24px" height="24px">
                    <path d="M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z"></path>
                    <path d="M0 0h24v24h-24z" fill="none"></path>
                </svg>
            </div>

            <div id="cxj-overlay-wrap">
                <form id="cxj-overlay-form" autocomplete="off">
                <a :href="overlay_data.href_url" target="_top">
                    <div class="item-image">
                    <img :src="overlay_data.img_path">
                    </div>
                </a>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import routeMixin from '../mixins/route.js';
export default {
    props: {
        route_list: Object,
    },
    mixins: [routeMixin],
    data() {
        return {
            overlay_data : {
                is_show: false,
                href_url: '',
                img_path: '',
            },
        }
    },
    computed : {
        overlayClass : function() {
            return this.overlay_data.is_show ? 'is-show' : '';
        }
    },
    methods: {
        closeOverlay() {
            this.overlay_data.is_show = false;
        },
        callOverlay() {
            let url = this.route(this.route_list, 'site.api.banner.overlay');
            axios.get(url, {
                params: {
                }
            }).then(res => {
                this.overlay_data = res.data.data;
                console.log(this.overlay_data);
            }).catch(error => {
            });
        }
    },
    mounted() {
    },
    created() {
        // 0.5秒だとwaitが足りないので1秒待つ
        setTimeout(() => {
            // OneTrust のjs 読み込み失敗時はoverlay を出す。
            if(typeof cmpConsentStatusPostMessageStorage == 'undefined') {
                console.log('cmpConsentStatusPostMessageStorage' + 'not found');
                this.callOverlay();
                return;
            }
            const shadowHost = document.querySelector('#datasign_cmp__host');
            if (!shadowHost || !shadowHost.shadowRoot) {
                this.callOverlay();
                return;
            }
            const targetNode = shadowHost.shadowRoot.querySelector('#datasign_cmp__cmp_summary');

            // 一回選択した後はsdk が出ないのでオーバーレイを出す。
            if (!targetNode) {
                this.callOverlay();
                return;
            }
        }, 1500);
    },
}
</script>

<style scoped>
#cxj-overlay-all-wrap {
    z-index: 99;
    padding: 5px;
    background-color: #FFFFFF;
    border: solid 1px #f0f0f0;
    background-color: #FFFFFF;
    box-shadow: 4px 4px 15px 0px rgba(0,0,0,0.25);
    position: fixed;
    right: 25px;
    bottom: 20px;
    z-index: 9999999999;
    opacity: 0;
    visibility: hidden;
    transform: translateY(200px);
    transition: all 2s;
    max-width: 300px;
}

#cxj-overlay-all-wrap.is-show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0px);
}

#cxj-overlay-all-wrap * {
    vertical-align: middle;
    font-weight: normal;
    line-height: 1.6em;
    font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "游ゴシック Medium", "Yu Gothic", YuGothic, Verdana, Meiryo, sans-serif !important;
}

#cxj-overlay-close {
    position: absolute;
    top: -18px;
    right: -18px;
    padding: 0.6rem;
    background: rgba(0,0,0,0.5);
    border-radius: 50%;
    transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
    cursor: pointer;
    z-index: 999;
}

#cxj-overlay-close svg {
    width: 24px;
    fill: #fff;
    pointer-events: none;
    vertical-align: top;
}

#cxj-overlay-wrap {
    width: 100%;
    overflow: hidden;
}

#cxj-overlay-form {
    display: inline-block;
    float: left;
    width: 200px;
    text-align: -webkit-center;
    text-align: center;
}

#cxj-overlay-all-wrap a {
    cursor: pointer;
}
</style>
